import { useState, useCallback } from 'react';

const STORAGE_KEY = 'trading_portfolio_basket';

/**
 * Manages the set of strategy names pinned to the portfolio builder.
 * Persisted to localStorage so it survives page reloads.
 */
const useBasket = () => {
  const [basket, setBasket] = useState(() => {
    try {
      return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'));
    } catch {
      return new Set();
    }
  });

  const toggle = useCallback((name) => {
    setBasket(prev => {
      const next = new Set(prev);
      if (next.has(name)) next.delete(name);
      else next.add(name);
      localStorage.setItem(STORAGE_KEY, JSON.stringify([...next]));
      return next;
    });
  }, []);

  const clear = useCallback(() => {
    setBasket(new Set());
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  return { basket, toggle, clear };
};

export default useBasket;
